enum Steps {
    previous = 'previous',
    next = 'next',
}

export default Steps;
